export default function NotificationsTab() {
    return (
        <h2>Notifications</h2>
    );
}